import { render, staticRenderFns } from "./ui-cascader.vue?vue&type=template&id=780f0854&scoped=true"
import script from "./ui-cascader.vue?vue&type=script&lang=js"
export * from "./ui-cascader.vue?vue&type=script&lang=js"
import style0 from "./ui-cascader.vue?vue&type=style&index=0&id=780f0854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780f0854",
  null
  
)

export default component.exports